import Account from "@/helper/AccountHelper.js";

const GOLD = 1;         // 0001
const PLATINUM = 2;     // 0010

export function UserLevel() {
    this.userLevel = Account.getUserLevel();

    this.isGold = function () {
        let rs = this.userLevel & GOLD;
        return rs != 0;
    };

    this.isPlatinum = function(){
        let rs = this.userLevel & PLATINUM;
        return rs != 0;
    }
}
